/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoListFilter { 
    q?: string;
    account_enabled?: boolean;
    anonimizzato?: boolean;
    user_id?: string;
}

